import { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ProductDetails from '../purchaseOrder/Navigation/ProductDetails';
import Transactions from '../purchaseOrder/Navigation/Transactions';
import { toast } from 'react-toastify';
import Table from '../../component/table/Table';
import ProfilePlaceHolder from '../../assets/image/emailPlaceHolder.svg';
import BlackClose from '../../assets/image/x-squareBlack.svg';
import { paymentModeColumn } from './purchaseBillsColoum';
import PageLoader from '../../component/PageLoader';
import pdfMake from 'pdfmake/build/pdfmake';
import Header from '../components/Header';
import ArrowUp from '../../assets/image/arrow_up.svg';
import ArrowDown from '../../assets/image/arrowD.svg';
import PurchaseBillInvoice from '../components/PurchaseBillInvoice';
import {
	deletePurchaseBill,
	fetchPurchaseBillDetails,
	generatePurchaseBillsPdf,
	getPurchaseBillDetails,
	undoPurchaseReceive,
} from '../../services/purchase_bill';
import ConfirmationModal from '../../component/modal/ConfirmationModal';
import { getDate } from '../../utils/dateUtils';
import ProductDetailsDrawer from '../components/ProductDetailsDrawer';
import { PurchaseOrderColoum } from '../PurchaseRecieved/purchaseReceivedColoum';
import { generatePurchaseBillPdf } from './components/generatePurchaseBillPdf';
import Button from '../../component/ui/Button';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../utils/controller';

const PurchaseBillDetails = () => {
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const param = useParams();
	const id = param?.id;
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const [purchaseBillDetails, setPurchaseBillDetails] = useState(null);
	const [purchaseOrderList, setPurchaseOrderList] = useState([]);
	const [purchaseRecievedList, setPurchaseRecievedList] = useState([]);
	const [paymentMade, setPaymentMade] = useState([]);
	const [activeTab, setActiveTab] = useState('bill');
	const [isProductDetailsSidebarOpen, setIsProductDetailsSidebarOpen] = useState(false);
	const [productDetails, setProductDetails] = useState(null);
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [isShowTable, setIsShowTable] = useState(false);
	const [isNameTable, setIsNameTable] = useState(0);
	const printPdfRef = useRef(null);
	const [isUndoReceive, setIsUndoReceive] = useState(false);
	const navTabs = ['Product Details', 'Transactions'];
	const [loader, setLoader] = useState(false);
	const returnScreen = () => {
		navigate(`/user/${suburl}/purchases-bills`);
	};

	const toggleSidebar = () => {
		setIsSidebarOpen(!isSidebarOpen);
	};

	const renderTabContent = () => {
		switch (activeTab) {
			case 'Product Details':
				return <ProductDetails />;
			case 'Transactions':
				return <Transactions />;
			default:
				return null;
		}
	};

	const Receivecolumn = [
		{
			field: 'PR#',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 50,
			flex: 1,
			cellStyle: { color: '#3B58FF' },
			headerStyle: { color: '#555B67' },
		},
		{
			field: 'DATE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellStyle: { color: '#555B67' },
			headerStyle: { color: '#555B67' },
		},
		{
			field: 'VENDOR NAME',
			suppressSizeToFit: true,
			minWidth: 40,
			flex: 1,
			cellClass: 'right-align',
			headerClass: 'HeaderBg right-align',
		},
		{
			field: 'STATUS',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellRenderer: (params) => {
				const status = params.data.STATUS ? 'Received' : 'Partially Received';
				return <>{status}</>;
			},
		},
	];

	async function handleDeletePurchaseBill() {
		try {
			await deletePurchaseBill([id]);
			toast.success('Purchase bill deleted successfully.');
			navigate(`/user/${suburl}/purchases-bills`);
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	async function generatePdfToPrintAndDownload() {
		const mergedDocDefinition = await generatePurchaseBillPdf([id]);
		pdfMake.createPdf(mergedDocDefinition).print();
	}

	async function handlePBPrintAndDownloadPdf(type = 'print') {
		try {
			setLoader(true);
			const pdf_details = await generatePurchaseBillsPdf(id);
			const url = pdf_details.signed_url;

			if (type === 'print') {
				window.open(url, '_blank');
			}

			if (type === 'download') {
				const fileName = `merged_purchase_bill_${Date.now()}.pdf`;
				const response = await fetch(url);
				const blob = await response.blob();
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(blobUrl);
			}
		} catch (err) {
		} finally {
			setLoader(false);
		}
	}

	async function handleFetchPurchaseBillDetails() {
		try {
			const { purchase_bill } = await getPurchaseBillDetails(id);
			setPurchaseBillDetails(purchase_bill);
			var purchaseBillPaymentMade =
				purchase_bill.purchase_bill_payment_made === null ||
				purchase_bill.purchase_bill_payment_made.length === 0
					? []
					: purchase_bill.purchase_bill_payment_made.map((pm) => {
							return {
								id: pm.payment_made_id,
								DATE: getDate(pm?.payment_made?.date),
								'PAYMENT#': pm?.payment_made?.payment_number,
								'REFERENCE#': pm.payment_made?.reference_number,
								'PAYMENT MODE': pm?.payment_made?.payment_mode,
								AMOUNT: Number(pm?.payment_amount).toFixed(2),
							};
						});
			setPaymentMade(purchaseBillPaymentMade);
			if (purchaseBillDetails?.purchase_receive !== null) {
				setPurchaseRecievedList([
					{
						id: purchase_bill?.purchase_receive?.purchase_receive_id,
						'PR#':
							purchase_bill?.purchase_receive?.purchase_receive_number ||
							'PR-' + purchase_bill?.purchase_receive?.purchase_receive_id,
						DATE: getDate(purchase_bill?.purchase_receive?.receive_date),
						'VENDOR NAME': purchase_bill?.vendor?.vendor_name,
						STATUS: purchase_bill?.purchase_receive?.status,
					},
				]);
			}
			if (purchase_bill?.purchase_order !== null) {
				setPurchaseOrderList([
					{
						id: purchase_bill?.purchase_order?.purchase_order_id,
						DATE: getDate(purchase_bill?.purchase_order?.date),
						'PO#': JSON.stringify({
							po_number: purchase_bill?.purchase_order?.purchase_order_number,
							is_draft: purchase_bill?.purchase_order?.is_draft,
						}),
						'VENDOR NAME': purchase_bill?.vendor?.vendor_name,
						STATUS: purchase_bill?.purchase_order?.status || 'N/A',
						RECEIVED: JSON.stringify({
							is_received: purchase_bill?.purchase_order?.is_received,
							is_partially_received: purchase_bill?.purchase_order?.is_partially_received,
							status: purchase_bill?.purchase_order?.status,
						}),
						BILLED: JSON.stringify({
							is_billed: purchase_bill?.purchase_order?.is_billed,
							is_partially_billed: purchase_bill?.purchase_order?.is_partially_billed,
						}),
						'Expected By':
							purchase_bill?.purchase_order?.expected_delivery_date === null
								? 'N/A'
								: getDate(purchase_bill?.purchase_order?.expected_delivery_date),
					},
				]);
			}
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	async function updateUndoReceivePurchaseBill() {
		try {
			await undoPurchaseReceive(id);
			returnScreen();
		} catch (error) {
			toast.error(error?.message || 'Something went wrong!');
		}
	}

	useEffect(() => {
		if (purchaseBillDetails) {
			document.title = `${purchaseBillDetails?.bill_number} | Purchase Bill Details | Pharmnex`;
		}
	}, [purchaseBillDetails]);

	useEffect(() => {
		handleFetchPurchaseBillDetails();
	}, [id]);

	return (
		<div style={{ backgroundColor: '#EDEDF7', height: '100%', overflowY: 'auto' }}>
			<div
				style={{
					position: 'sticky',
					top: 0,
					zIndex: 30,
					backgroundColor: '#EDEDF7',
					boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
				}}
			>
				<Header
					headerTitle="Purchase Bills Details"
					closeButton={{
						showCloseButton: true,
						handler: () => returnScreen(),
					}}
					buttons={[
						{
							id: 1,
							className: 'btn-gray mt-0 px-4 ',
							disabled: !hasPermission(
								'purchase.purchase_bills.edit',
								user?.role?.role_permissions,
							),
							button: 'Edit',
							handler: () => navigate(`/user/${suburl}/purchases-bills-create/${id}`),
						},
						{
							id: 2,
							className: 'btn-gray mt-0 px-4',
							disabled: !hasPermission(
								'purchase.purchase_bills.download_or_print_pdf',
								user?.role?.role_permissions,
							),
							button: 'PDF/Print',
							loader: loader,
							handler: () => handlePBPrintAndDownloadPdf(),
						},
						{
							id: 3,
							className: 'btn-gray',
							disabled: !hasPermission(
								'purchase.purchase_bills.delete',
								user?.role?.role_permissions,
							),
							button: 'Delete',
							handler: () => setIsDeleteModalOpen(true),
						},

						...(purchaseBillDetails &&
						purchaseBillDetails?.status !== 0 &&
						purchaseBillDetails?.status !== 3 &&
						Number(purchaseBillDetails.due_amount) > 0
							? [
									{
										id: 4,
										className: 'mt-0 btn-gray add-pro',
										disabled: !hasPermission(
											'purchase.payment_made.create',
											user?.role?.role_permissions,
										),
										button: 'Create Payment Made',
										handler: () => {
											navigate(`/user/${suburl}/payment-made-create`, {
												state: { key: purchaseBillDetails?.vendor_id, value: '' },
											});
										},
									},
								]
							: []),
						...(purchaseBillDetails && Number(purchaseBillDetails.excess_amount) > 0
							? [
									{
										id: 6,
										className: 'mt-0 btn-gray add-pro',
										button: 'Create Credit Note',
										disabled: true,
									},
								]
							: []),
						{
							id: 7,
							className: 'btn-gray add-pro',
							button: 'Clone',
							disabled: true,
						},

						...(purchaseBillDetails &&
						purchaseBillDetails?.status !== 0 &&
						purchaseBillDetails?.status !== 3 &&
						Number(purchaseBillDetails.due_amount) < 0
							? [
									{
										id: 8,
										className: 'mt-0 btn-gray add-pro',
										button: 'Undo Receive',
										disabled: false,
										handler: () => setIsUndoReceive(true),
									},
								]
							: []),
					]}
				/>
				<div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
							alignItems: 'center',
							backgroundColor: '#F6F6F9',
						}}
					>
						<div className="tabs">
							<div
								className={`tab ${isNameTable === 0 ? 'active' : 'inactive'}`}
								onClick={() => {
									setIsNameTable(0);
									setIsShowTable(true);
								}}
								style={{ fontSize: '16px', fontWeight: 'bold' }}
							>
								Purchase Order
								<span
									style={{
										borderRadius: '5px',
										color: '#3B58FF',
										marginLeft: '7px',
									}}
								>
									{purchaseOrderList?.length}
								</span>
							</div>
							<div
								className={`tab ${isNameTable === 1 ? 'active' : 'inactive'}`}
								onClick={() => {
									setIsNameTable(1);
									setIsShowTable(true);
								}}
								style={{ fontSize: '16px', fontWeight: 'bold' }}
							>
								Purchase Recieved
								<span
									style={{
										borderRadius: '5px',
										color: '#3B58FF',
										marginLeft: '7px',
									}}
								>
									{purchaseRecievedList?.length}
								</span>
							</div>
							<div
								className={`tab ${isNameTable === 2 ? 'active' : 'inactive'}`}
								onClick={() => {
									setIsNameTable(2);
									setIsShowTable(true);
								}}
								style={{ fontSize: '16px', fontWeight: 'bold' }}
							>
								Payment Made
								<span
									style={{
										borderRadius: '5px',
										color: '#3B58FF',
										marginLeft: '7px',
									}}
								>
									{paymentMade?.length}
								</span>
							</div>
						</div>
						<div
							style={{
								padding: '0px 10px',
							}}
						>
							{isShowTable ? (
								<img
									style={{
										cursor: 'pointer',
									}}
									src={ArrowUp}
									onClick={() => setIsShowTable(false)}
								/>
							) : (
								<img
									style={{
										cursor: 'pointer',
									}}
									src={ArrowDown}
									onClick={() => setIsShowTable(true)}
								/>
							)}
						</div>
					</div>

					{isShowTable && isNameTable === 0 && purchaseOrderList.length > 0 && (
						<div style={styles.table}>
							<Table
								coloum={PurchaseOrderColoum}
								row={purchaseOrderList}
								onRowClick={(id) => {
									if (id) {
										navigate(`/user/${suburl}/purchases-order-details/${id}`);
									}
								}}
								style={{ height: '210px', padding: '0%' }}
							/>
						</div>
					)}
					{isShowTable && isNameTable === 1 && purchaseRecievedList.length > 0 && (
						<div style={styles.table}>
							<Table
								coloum={Receivecolumn}
								row={purchaseRecievedList}
								onRowClick={(id) => {
									navigate(`/user/${suburl}/purchases-receive-details/${id}`);
								}}
								style={{ height: '210px', padding: '0%' }}
							/>
						</div>
					)}
					{isShowTable && isNameTable === 2 && paymentMade.length > 0 && (
						<div style={styles.table}>
							<Table
								coloum={paymentModeColumn}
								row={paymentMade}
								onRowClick={(rowId) => {
									navigate(`/user/${suburl}/payment-made-details/${rowId}`);
								}}
								style={{ height: '210px', padding: '0%' }}
							/>
						</div>
					)}

					<style>
						{`
          .tabs {
            display: flex;
            font-size: 16px;
            font-weight: 400;
            background-color: #F6F6F9;
            height: 54px;
          }

          .tab {
            padding: 10px 20px;
            cursor: pointer;
            position: relative;
            transition: all 0.3s ease;
          }

          .tab.active {
            color: #000000;
            font-weight: bold;
          }

          .tab.inactive {
            color: #555B67; 
            font-weight: normal;
          }

          .tab.active::after {
            content: '';
            position: absolute;
            width: 75%;
            height: 3px;
            background-color: #3B58FF;
            bottom: 13px;
            left: 15px;
          }
        `}
					</style>
				</div>
				{purchaseBillDetails && Number(purchaseBillDetails.excess_amount) > 0 && (
					<div
						style={{
							backgroundColor: '#FFC008',
							padding: '10px 0px',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							borderTop: '1px solid #ccc',
						}}
					>
						<div
							style={{ color: '#000', fontSize: '14px', fontWeight: '600', marginRight: '10px' }}
						>
							Action Required: Excess amount pending. Adjusting this amount is required.
						</div>
						<Button
							type="button"
							className="mx-1 btn-primary add-pro"
							button="Create Credit Note"
							onClick={() => {
								navigate(`/user/${suburl}/credit-note-create/purchase-bill=${id}`, {
									state: {
										key: purchaseBillDetails?.vendor?.vendor_id,
										name: purchaseBillDetails?.vendor?.vendor_name,
									},
								});
							}}
						/>
					</div>
				)}
			</div>

			{!purchaseBillDetails ? (
				<PageLoader />
			) : (
				<div>
					<PurchaseBillInvoice
						printPdfRef={printPdfRef}
						handleProduct={(product) => {
							setProductDetails(product);
							setIsProductDetailsSidebarOpen(true);
						}}
						purchaseBillDetails={purchaseBillDetails}
					/>
				</div>
			)}

			{/* Sidebar ka layout */}
			{isProductDetailsSidebarOpen && (
				<ProductDetailsDrawer
					id={productDetails?.product_id}
					vendor={{
						vendor_id: purchaseBillDetails?.vendor?.vendor_id,
						vendor_name: purchaseBillDetails?.vendor?.vendor_name,
					}}
					setIsSidebarOpen={setIsProductDetailsSidebarOpen}
				/>
			)}

			{/* Sidebar ka layout */}
			{isSidebarOpen && (
				<div className="sidebar">
					<div
						className="d-flex align-self-center justify-content-sm-between "
						style={{ gap: '60px' }}
					>
						<div className="VenderDetails">Vendor Details</div>

						<div
							className="d-flex align-self-center "
							style={{ gap: '26px', alignItems: 'center' }}
						>
							<div>
								<a href="#">View more details</a>
							</div>

							<div
								className="SidebaarCloseBTN d-flex align-self-center justify-content-sm-center"
								onClick={toggleSidebar}
							>
								<img
									src={BlackClose}
									alt=""
									style={{ width: '14px', cursor: 'pointer' }}
								/>
							</div>
						</div>
					</div>

					<br />

					<div
						className="d-flex"
						style={{ gap: '20px' }}
					>
						<div className="profileImage d-flex align-self-center justify-content-sm-center">
							<img
								src={ProfilePlaceHolder}
								alt=""
								style={{ width: '55px', borderRadius: '10px' }}
							/>
						</div>

						<div
							className="d-flex flex-column"
							style={{ gap: '15px' }}
						>
							<div
								style={{
									fontSize: '18px',
									fontWeight: '600',
									color: '#333',
								}}
							>
								Shree Ram Medicals
							</div>

							<div
								style={{
									fontSize: '14px',
									color: 'var(--sub, #555B67)',
								}}
							>
								<b>Strip</b> contains <b>10 Tablets</b>
							</div>
						</div>
					</div>
					<br />
					<hr />

					{/* tabs  */}
					<div>
						<ul className="nav mb-4 mt-2">
							{navTabs.map((item, index) => (
								<li
									key={index}
									className="nav-item"
								>
									<a
										className={`nav-link ${activeTab === item ? 'active' : ''} cursur-pointer`}
										href="#"
										onClick={(e) => {
											e.preventDefault();
											setActiveTab(item);
										}}
									>
										{item}
									</a>
								</li>
							))}
						</ul>
						<hr
							style={{
								backgroundColor: '#E3E4E5',
								boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
								marginTop: '-13px',
							}}
						/>
						<div>{renderTabContent()}</div>
					</div>
				</div>
			)}
			<ConfirmationModal
				isOpen={isUndoReceive}
				onClose={() => setIsUndoReceive(false)}
				title="Confirm Deletion"
				content={
					<p
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '10px',
							borderRadius: '5px',
							fontWeight: '500',
							color: 'black',
						}}
					>
						{`Are you sure undo receive of purchase bill`}
					</p>
				}
				onCancel={() => setIsUndoReceive(false)}
				onOk={updateUndoReceivePurchaseBill}
			/>
			<ConfirmationModal
				isOpen={isDeleteModalOpen}
				title="Confirm Deletion"
				content={
					<p
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '10px',
							borderRadius: '5px',
							fontWeight: '500',
							color: 'black',
						}}
					>
						{purchaseBillDetails && purchaseBillDetails.purchase_bill_payment_made.length > 0
							? 'This Purchase Bill has associated payments. Deleting the bill will also delete the linked payment records. Are you sure you want to proceed?'
							: `Are you sure delete ${purchaseBillDetails?.bill_number} of Purchase Bill ?`}
					</p>
				}
				onCancel={() => setIsDeleteModalOpen(false)}
				onOk={handleDeletePurchaseBill}
			/>
		</div>
	);
};
const styles = {
	table: {
		margin: 'auto',
		overflowY: 'hidden',
		overflowX: 'hidden',
		borderBottom: '3px solid #C3CBDC',
	},
	tableContainer: {
		marginTop: '20px',
		overflowY: 'hidden',
		width: '626px',
	},
};
export default PurchaseBillDetails;
